<template>
  <div style="height: 100%">
    <div
      style="
        height: 100%;
        padding: 0 2.0833rem;
        display: flex;
        flex-flow: column nowrap;
      "
    >
      <zj-layout-header>
        <el-input
          style="margin-bottom: 2rem; border: 1px solid #2ac1ff"
          placeholder="请输入人员名称进行搜索"
          v-model="queryParams.userName"
          @keyup.native="getList"
        ></el-input>
      </zj-layout-header>
      <zj-layout-main class="table-chart">
        <el-table
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 100%; color: red"
          fixed
        >
          <el-table-column
            prop="userName"
            label="姓名"
            show-overflow-tooltip
            min-width="28%"
          ></el-table-column>
          <el-table-column
            prop="dept.deptName"
            label="部门"
            min-width="28%"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="phonenumber"
            label="电话"
            min-width="28%"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column min-width="16%">
            <template slot-scope="scope">
              <img
                slot="icon"
                src="../../../theme-default/src/img/icon_task.png"
                @click="addTask(scope.row.userName, scope.row.userId)"
                style="width: 0.9167rem"
              />
            </template>
          </el-table-column>
        </el-table>
      </zj-layout-main>
      <div class="footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="prev, pager, next"
          background
          :total="total"
        ></el-pagination>
      </div>
      <div class="addBtn" @click="addTask('','')">+新增任务</div>

      <el-dialog
        class="emergencyoperations-dialog normal"
        custom-class="bg3"
        top="6vh"
        :modal-append-to-body="false"
        :append-to-body="true"
        :visible.sync="isShowPop"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
      >
        <NewTask
          @handlerclose="isShowPop = false"
          :receiverName="receiverName"
          :receiverId="receiverId"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import { listUser } from "@/api/system/permission/user";
import NewTask from "./Component-NewTask-Home";

export default {
  name: "HomeViewCommunicate",
  componentName: "HomeViewCommunicate",

  props: {},
  components: {
    NewTask,
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],

      // 查询参数
      queryParams: {
        userName: "",
        phonenumber: "",
        status: "",
        pageNum: 1,
        pageSize: 10,
      },
      isShowPop: false,
      receiverName: null,
      receiverId: null,
    };
  },

  mounted: function () {
    this.getList();
  },
  methods: {
    // 查询用户列表
    getList() {
      this.loading = true;
      listUser(this.queryParams).then((response) => {
        this.tableData = response.rows;
        this.total = parseInt(response.total);
        this.loading = false;
      });
    },
    // 点击每页显示的条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    addTask(userName, userId) {
      this.isShowPop = true;
      this.receiverName = userName;
      this.receiverId = userId;
    },
    newtaskcreated() {
      this.isShowPop = false;
    },
  },
};
</script>
<style scoped>
.footer {
  padding-bottom: 7.0833rem !important;
}
</style>